import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
// import Project from "./pages/Project";
// import About from "./pages/About";
// import Header from "./components/Header";
import { useState } from "react";
// import anime from "animejs";
import NotFound from "./pages/NotFound";
import { AnimatePresence } from "framer-motion";

function App() {
  const isBrowserDefaultDark = () =>
    window.matchMedia("(prefers-color-scheme:dark)").matches;

  // eslint-disable-next-line
  const [theme, setTheme] = useState(isBrowserDefaultDark() ? "dark" : "light");

  // const toggle = () => {
  //   setTheme(theme === "light" ? "dark" : "light");
  // };

  // anime({
  //   target: "#header",
  //   translateY: 100,
  //   duration: 200,
  //   direction: "normal",
  //   easing: "easeInOutQuad",
  //   autoplay: true,
  // });

  const location = useLocation();

  return (
    <div
      className="App user-select-none d-flex flex-column min-vh-100"
      data-bs-theme={theme}
    >
      {/* <Header id="header" theme={theme} toggle={toggle} /> */}
      <AnimatePresence>
        <Routes location={location} key={location.key}>
          <Route path="/" element={<Home />} />
          {/* <Route path="/projects" element={<Project />} />
          <Route path="/about" element={<About />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
